/**
 * Typen und Hilfen des Reiters „USV" auf der Seite Sicherheitsstrom (W2-A1, 16.10.2026).
 *
 * Die Typen folgen `GET …/elektro/usv` (SicherheitsstromEndpoints.cs, Usvlauf.cs). Gerechnet wird beim
 * Abruf; die Seite schreibt nichts.
 */

export const USV_BEDARF_HINWEIS =
  'Bedarf, kein Gerätenachweis: Im Modell sind weder USV-Leistung noch Batterie gepflegt. Die Zahlen stehen auf '
  + 'den Lasten des Modells (IT-Verteiler, USV-Steckdosen) und auf unbestätigten Vorgaben (Planungsannahmen bis '
  + 'zur Wahl von USV und Batterie).';

export interface UsvKennzahlen {
  itVerteiler: number; itOhneLeistung: number; itNormalnetz: number; usvSteckdosen: number;
  dosenOhneKreis: number; dosenKreise: number; dosenKreiseNormal: number; usvSchraenke: number;
  befunde: number; warnungen: number; aufAnnahmen: boolean;
}

export interface UsvGruppe { name: string; anzahl: number; lastBetriebW: number; herleitung: string }

export interface UsvBemessung {
  gruppe: string; lastBetriebW: number; lastAnlageW: number; scheinleistungVa: number; autonomieMin: number;
  dcSpannungV: number; zellen: number; entladestromA: number; entnommenAh: number; mindestbedarfAh: number;
  kapazitaetErforderlichAh: number; energieWh: number; ladestromA: number; ladeleistungW: number;
  eingangsleistungW: number; lueftungM3h: number; lueftungQuerschnittCm2: number; rechenweg: string[];
}

export interface UsvItVerteiler {
  kennzeichen: string; raumnummer: string | null; versorgungsart: string; einspeisung: string | null;
  bedarfsleistungW: number | null; dezentral: UsvBemessung | null;
}

export interface UsvDosen { verteiler: string; versorgungsart: string; kreise: number; dosen: number }

export interface UsvSchrank { bezeichnung: string; typ: string | null; raumnummer: string | null; datenstand: string }

export interface UsvVorgabe {
  feld: string; verwendung: string | null; wert: string; einheit: string | null; bestaetigt: boolean;
  herkunft: string; normbezug: string | null; rueckfall: boolean;
}

export interface UsvStand {
  kennzahlen: UsvKennzahlen;
  gruppen: UsvGruppe[];
  gesamt: UsvBemessung;
  jeGruppe: UsvBemessung[];
  itVerteiler: UsvItVerteiler[];
  dosen: UsvDosen[];
  schraenke: UsvSchrank[];
  vorgaben: UsvVorgabe[];
  befunde: string[];
  stand: string;
}

/** kW bzw. kVA mit einer Nachkommastelle. */
export function kilo(wert: number): string {
  return (wert / 1000).toLocaleString('de-DE', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
}
